export const THEMES: any = {
  NorthAmerica: {
    globalBackground:
      'linear-gradient(0.45turn, #462977,#9872DB,#B69CE5,#D3C3EF)',
    primaryColor: 'white',
    secondaryColor: '#eee7f980',
    primaryBg: '#462977',
    secondChartColor: '#9872DB',
    thirdChartColor: '#B69CE5',
    fourthChartColor: '#D3C3EF',
    spinerBorderColor: '#D3C3EF',
  },
  MiddleEast: {
    globalBackground:
      'linear-gradient(0.45turn, #81AC1D,#B3CF6D,#C9DD98,#DFEAC0)',
    primaryColor: '#412b74',
    secondaryColor: '#f6fbe9',
    primaryBg: '#81AC1D',
    secondChartColor: '#B3CF6D',
    thirdChartColor: '#C9DD98',
    fourthChartColor: '#DFEAC0',
    spinerBorderColor: '#DFEAC0',
  },
};
